import React, { useContext } from 'react';
import { BrandingContext } from '../contexts/ContractContext';
import NJRLanding from '../NJRLanding/NJRLanding';
import AppleLanding from '../AppleLanding/AppleLanding';

const Home = () => {
    const branding = useContext(BrandingContext);
    const { clientId } = branding;

    const getClientSpecificLanding = () => {
        switch (clientId?.toLowerCase()) {
            case 'njr':
                return <NJRLanding />;
            case 'apple':
                return <AppleLanding />;
            default:
                return <AppleLanding />;
        }
    };

    return <>{getClientSpecificLanding()}</>;
};

export default Home;
